export default __webpack_public_path__ + "bg_anli_jiaoyu024dcb0a.png";